const RootWrapper = require("sites-common/gatsby-utils/WrapRoot").default;
const WrapPageAccessControl =
  require("gatsby-plugin-hfn-profile/auth/WrapPageAccessControl").default;
require("sites-common/gatsby-utils/setupOfficeFabric");
const React = require("react");
const { navigate } = require("@reach/router");
const PropTypes = require("prop-types");

const appConfigRoutes = require("./gatsby-apps-config");

const homeConfig = require("./src/components/HomeComponents/AppConfig").default;

const apps = Object.keys(appConfigRoutes);

const getMandatoryEnv = require("sites-common/utils/getMandatoryEnv");
const { default: WrapPage } = require("sites-common/gatsby-utils/WrapPage");

const { myloginType } = getMandatoryEnv(["myloginType"]);

function RenderHeader({ Header, isHome, appHome }) {
  const goHome = React.useCallback(() => navigate(appHome), [appHome]);

  return React.createElement(Header, { isHome, goHome });
}

RenderHeader.propTypes = {
  Header: PropTypes.element.isRequired,
  isHome: PropTypes.bool.isRequired,
  appHome: PropTypes.func.isRequired,
};

function WrapLayout({ element, props }) {
  const { path } = props;

  let Config = homeConfig;
  let isHome = false;
  let appHome = path;

  if (path === "/") {
    isHome = true;
    Config = homeConfig;
  } else {
    apps.forEach((p) => {
      if (path.startsWith(p)) {
        if (path === p) {
          isHome = true;
        }
        appHome = p;
        Config = appConfigRoutes[p].config;
      }
    });
  }

  const accessControl =
    "accessControl" in Config ? Config.accessControl : homeConfig.accessControl;

  return (path?.includes("oneauth/authorization") || path?.includes("embedded")) ? (
    <>
      {path?.includes("oneauth/authorization") && <RenderHeader Header={Config.Header} isHome={isHome} appHome={appHome} />}
      <WrapPage element={element} props={props} />
    </>
  ) : (
    <>
      <RenderHeader Header={Config.Header} isHome={isHome} appHome={appHome} />
      <WrapPageAccessControl
        element={element}
        accessControl={accessControl}
        myloginType={myloginType}
      />
    </>
  );
}

WrapLayout.propTypes = {
  element: PropTypes.element.isRequired,
  props: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
};

exports.wrapPageElement = WrapLayout;
exports.wrapRootElement = RootWrapper;
